import React, { useEffect, useState } from "react";
import { Button, Modal, Form, Switch, Divider } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import {
	deleteQuestion,
	fetchQuestion,
	updateQuestion,
	fetchQuestions,
} from "../../actions/question";

import "./Question.scss";
import { DateTimeFormat } from "../../helpers/utils";
import { ReactSVG } from "react-svg";
import { Link, useHistory } from "react-router-dom";
import AnswerRadio from "../Shared/AnswerRadio";
import AnswerMultiChoice from "../Shared/AnswerMultiChoice";
import QuestionForm from "../Forms/Question";
import { PAGE_SIZE } from "../../constants";

const QuestionPage = () => {
	const { id } = useParams();
	const history = useHistory();
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [questionId, setQuestionId] = useState(null);
	const { status, question } = useSelector((state) => state.fetchQuestion);
	const { status: updateStatus } = useSelector((state) => state.updateQuestion);
	const { questionDeleted } = useSelector((state) => state.deleteQuestion);
	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
	};

	const handleEdit = () => {
		showModal();
		setQuestionId(question.id);
	};

	const handleDelete = () => {
		dispatch(deleteQuestion(question.id));
	};

	const handleSubmitForm = (values) => {
		const newValues = { ...values };

		if (questionId) {
			if (newValues.require === undefined) newValues.require = false;
			dispatch(updateQuestion(questionId, newValues));
		}
		handleOk();
	};

	useEffect(() => {
		if (status === "IDLE") {
			dispatch(fetchQuestion(id));
		}
	}, [status]);

	useEffect(() => {
		if (updateStatus === "SUCCEEDED") dispatch(fetchQuestion(id));
	}, [updateStatus]);

	useEffect(() => {
		if (questionDeleted) {
			dispatch(fetchQuestions({ start: 0, count: PAGE_SIZE }));
			history.push("/questions");
		}
	}, [questionDeleted]);

	return (
		<div id="question-container">
			<div className="page-header">
				<h2 className="page-header-title">Question Details</h2>
			</div>
			<div className="page-header-details-actions">
				<div className="left">
					<Link to="/questions">
						<Button type="link" className="btn btn-back">
							<ReactSVG src="/icons/arrow-left.svg" />
							Back
						</Button>
					</Link>
				</div>
				<div className="right">
					<Button
						type="primary"
						className="btn-primary"
						onClick={() => handleEdit()}
					>
						Edit
						<ReactSVG src="/icons/edit.svg" />
					</Button>
					<Button className="btn btn-danger" onClick={() => handleDelete()}>
						Delete
						<ReactSVG src="/icons/delete-all.svg" />
					</Button>
				</div>
			</div>
			{status === "SUCCEEDED" && (
				<div className="page-content">
					<div className="page-details-section">
						<div>
							<div className="box">
								<div className="box-header">
									<h2 className="box-title">Details</h2>
								</div>
								<div className="box-content">
									<div className="details-item">
										<label>Name</label>
										<div className="text">{question.name}</div>
									</div>
									<div className="details-item">
										<label>Type</label>
										<div className="text">{question.type}</div>
									</div>
									<div className="details-item">
										<label>Question Kind</label>
										<div className="text">{question.question_kind}</div>
									</div>
									<div className="details-item">
										<label>Survey Category</label>
										<div className="text">{question.survey_category.name}</div>
									</div>
									<div className="details-item">
										<label>Require</label>
										<div className="text">
											<Switch defaultChecked={question.require} />
										</div>
									</div>
									<div className="details-item">
										<label>Updated At</label>
										<div className="text">
											{DateTimeFormat(question.updated_at)}
										</div>
									</div>
									<div className="details-item">
										<label>Created At</label>
										<div className="text">
											{DateTimeFormat(question.created_at)}
										</div>
									</div>
									<Divider />
									<div className="box-header">
										<h2 className="box-title">Answers</h2>
									</div>
									<div className="answers-section">
										{question.question_kind === "radio" ? (
											<AnswerRadio question={question} />
										) : (
											<AnswerMultiChoice question={question} />
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
			<Modal
				className="add-category-modal"
				visible={isModalVisible}
				onOk={handleOk}
				onCancel={handleCancel}
				footer={null}
			>
				<QuestionForm
					form={form}
					questionId={questionId}
					handleSubmitForm={handleSubmitForm}
					handleCancel={handleCancel}
				/>
			</Modal>
		</div>
	);
};

export default QuestionPage;
